import type { Border, BorderStyledProps, GetStyles, Split } from '@sds-system/types';

import { getColorValue } from '.';

export const getBorderStyles: GetStyles<BorderStyledProps> = ({
  border,
  borderColor,
  borderStyle,
  borderWidth,
  br,
  theme,
}) => {
  const splitBorder = (border?.split(' ') || []) as Split<' ', Border>;

  return {
    border:
      splitBorder.length === 3
        ? `${theme.borderSize[splitBorder[0]]}px ${splitBorder[1]} ${getColorValue(splitBorder[2], theme)}`
        : '',
    borderColor: borderColor && getColorValue(borderColor, theme),
    borderStyle,
    borderWidth: borderWidth && theme.borderSize[borderWidth],
    borderRadius: br && theme.borderRadius[br],
  };
};
